<template>
    <v-content>
        <v-container
            id="bg"
            class="fill-height"
            fluid
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="4"
                    lg="4"
                    xl="2"
                >
                    <v-alert v-if="serverError" type="error">
                        {{ serverError }}
                    </v-alert>
                    <v-card class="elevation-4" :loading="isLoading">
                        <v-toolbar
                            color=primary
                            dark
                        >
                            <v-toolbar-title>Login</v-toolbar-title>
                        </v-toolbar>
                        <form @submit.prevent="login">
                            <v-card-text>
                                <v-text-field
                                    v-model="username"
                                    label="Login"
                                    name="username"
                                    prepend-icon="mdi-account"
                                    type="text"
                                ></v-text-field>

                                <v-text-field
                                    v-model="password"
                                    id="password"
                                    label="Password"
                                    name="password"
                                    prepend-icon="mdi-lock"
                                    type="password"
                                    autocomplete="on"
                                ></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn type="submit" color="success">Login</v-btn>
                            </v-card-actions>
                        </form>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>

    export default {
        name: "Login",

        data: () => ({
            username: '',
            password: '',
            serverError: '',
            isLoading: false
        }),

        computed: {
            csrf_token() {
                let token = document.head.querySelector('meta[name="csrf-token"]')
                return token.content
            }
        },

        methods: {
            login() {
                this.isLoading = true

                this.$store.dispatch('retrieveToken', {
                    username: this.username,
                    password: this.password
                })
                    .then(response => {
                        this.$router.push({name: 'Profile'})
                        this.isLoading = false
                    })
                    .catch(error => {
                        this.serverError = error.data
                        this.password = ''
                        this.isLoading = false
                    })
            }
        }

    };
</script>

<style>
    #bg{
        /*background-image: url("https://cdn.pixabay.com/photo/2020/03/08/23/23/coronavirus-4914026_960_720.jpg");*/
        background-image: url("https://cdn.pixabay.com/photo/2015/12/08/01/04/bookshelf-1082309_960_720.jpg");
        /*background-image: url("https://cdn.pixabay.com/photo/2015/06/08/15/11/typewriter-801921_960_720.jpg");*/
        /*background-image: url("https://cdn.pixabay.com/photo/2015/11/19/21/10/knowledge-1052010_960_720.jpg");*/
        background-position: center;
        background-size: cover;
    }
</style>
